import { render, staticRenderFns } from "./addPaymentMethod.vue?vue&type=template&id=f23ea12c&"
import script from "./addPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./addPaymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports